<script>
/**
 * Type        : Business component
 * Title       : 파트너사 목록
 * Description : 파트너사 목록을 보여주는 컴포넌트
 * 
 *              - 파트너사 목록을 보여준다
 * 
 */

import PartnerInfoForm from '@/components/admin/common/modal/PartnerInfoForm.vue'


export default {
  name: "PartnerList",
  components: {
    PartnerInfoForm
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      partnerList       : [],
      selectedList      : [],
      partnerModifyModalShow   : false,
      modalMode: 'modify',
      filters: {
        keyword: '',
        contractType: 'all',
        contractStatus: 'all'
      },
      contractTypeOptions: [
        { label: '전체', value: 'all' },
        { label: 'LOGIS 계약', value: 'logis' },
        { label: 'FULFILLMENT 계약', value: 'fulfillment' },
        { label: '둘 다 계약', value: 'both' },
        { label: '계약 없음', value: 'none' }
      ],
      contractStatusOptions: [
        { label: '전체', value: 'all' },
        { label: '계약중', value: 'active' },
        { label: '만료 예정', value: 'expiring' },
        { label: '계약 종료', value: 'expired' }
      ],
      columns: [
        { name: 'id', label: 'ID', align: 'center', field: 'id', format: val => `${val}`, sortable: true },
        { name: 'partner_name', label: '파트너명', align: 'center', field: 'partner_name' },
        { 
          name: 'business_number', 
          label: '사업자번호', 
          align: 'center', 
          field: 'business_number',
          format: val => this.$formatBusinessNumber(val)
         },
        { name: 'ceo_name', label: '대표자명', align: 'center', field: 'ceo_name' },
        { name: 'business_type', label: '업종', align: 'center', field: 'business_type' },
        { 
          name: 'phone', 
          label: '전화번호', 
          align: 'center', 
          field: 'phone',
          format: val => this.$formatPhoneNumber(val, 'home')
         },
        { name: 'email', label: '이메일', align: 'center', field: 'email' },
        { name: 'address', label: '주소', align: 'center', field: 'address' },
        { name: 'admin_name', label: '담당자명', align: 'center', field: 'admin_name' },
        { 
          name: 'admin_phone', 
          label: '담당자 연락처', 
          align: 'center', 
          field: 'admin_phone',
          format: val => this.$formatPhoneNumber(val, 'home')
         },
        { name: 'admin_email', label: '담당자 이메일', align: 'center', field: 'admin_email' },

        { name: 'item_categories', label: '상품분류', align: 'center', field: 'item_categories' },
        { name: 'pickup_area', label: '집화지역', align: 'center', field: 'pickup_area' },
        { name: 'contract_start_date', label: '계약시작일', align: 'center', field: 'contract_start_date' },
        { name: 'contract_end_date', label: '계약종료일', align: 'center', field: 'contract_end_date' },
        {
          name: 'has_logis_contract',
          label: 'LOGIS 계약',
          align: 'center',
          field: 'has_logis_contract',
          format: (val) => Number(val) === 1 ? 'Y' : 'N'
        },
        {
          name: 'has_fulfillment_contract',
          label: 'FULFILLMENT 계약',
          align: 'center',
          field: 'has_fulfillment_contract',
          format: (val) => Number(val) === 1 ? 'Y' : 'N'
        },
        // { name: 'monthly_estimate_volume', label: '월 예상 물량', align: 'center', field: 'monthly_estimate_volume' },

        { name: 'created_at', label: '등록일', align: 'center', field: 'created_at' },
        { name: 'updated_at', label: '수정일', align: 'center', field: 'updated_at' }
      ],
    }
  },
  computed: {
    session() {
      return this.$store.getters.getLocalSession || {}
    },
    filteredPartnerList() {
      return this.partnerList.filter(row => this.matchesKeyword(row)
        && this.matchesContractType(row)
        && this.matchesContractStatus(row))
    },
    summaryCards() {
      const total = this.partnerList.length
      const logis = this.partnerList.filter(row => Number(row.has_logis_contract) === 1).length
      const fulfillment = this.partnerList.filter(row => Number(row.has_fulfillment_contract) === 1).length
      const both = this.partnerList.filter(row => Number(row.has_logis_contract) === 1 && Number(row.has_fulfillment_contract) === 1).length
      const expiring = this.partnerList.filter(row => this.getContractStatus(row) === 'expiring').length

      return [
        { label: '전체 파트너', value: total, icon: 'groups', color: 'primary' },
        { label: 'LOGIS 계약', value: logis, icon: 'local_shipping', color: 'blue-7' },
        { label: 'FULFILLMENT 계약', value: fulfillment, icon: 'inventory_2', color: 'teal-7' },
        { label: '복수 계약', value: both, icon: 'hub', color: 'deep-orange-7' },
        { label: '만료 예정', value: expiring, icon: 'event_busy', color: 'negative' }
      ]
    }
  },
  methods:{
    includesText(value, keyword) {
      return String(value || '').toLowerCase().includes(keyword)
    },

    matchesKeyword(row) {
      const keyword = String(this.filters.keyword || '').trim().toLowerCase()
      if (!keyword) return true

      return [
        row.partner_name,
        row.business_number,
        row.ceo_name,
        row.phone,
        row.email,
        row.address,
        row.admin_name,
        row.admin_phone,
        row.admin_email,
        row.item_categories,
        row.pickup_area
      ].some(value => this.includesText(value, keyword))
    },

    matchesContractType(row) {
      const type = this.filters.contractType
      const hasLogis = Number(row.has_logis_contract) === 1
      const hasFulfillment = Number(row.has_fulfillment_contract) === 1

      if (type === 'logis') return hasLogis
      if (type === 'fulfillment') return hasFulfillment
      if (type === 'both') return hasLogis && hasFulfillment
      if (type === 'none') return !hasLogis && !hasFulfillment
      return true
    },

    getContractStatus(row) {
      if (!row.contract_end_date) return 'active'

      const endDate = new Date(`${row.contract_end_date}T23:59:59`)
      if (Number.isNaN(endDate.getTime())) return 'active'

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      if (endDate < today) return 'expired'

      const daysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24))
      return daysLeft <= 30 ? 'expiring' : 'active'
    },

    matchesContractStatus(row) {
      if (this.filters.contractStatus === 'all') return true
      return this.getContractStatus(row) === this.filters.contractStatus
    },

    resetFilters() {
      this.filters = {
        keyword: '',
        contractType: 'all',
        contractStatus: 'all'
      }
    },

    /**
     * Title        : 파트너사 목록 불러오기
     * Status       : Actived
     * Description  : 파트너사 목록을 불러온다
     */
    async getPartnerList(){

      let config = {
        method  : "POST",
        url     : "/api/partner/getPartnerList",
        name    : "[ Axios / PartnerList / 파트너사 목록조회 ]"
      }

      await this.$http(config)
        .then((res) => {
          this.partnerList = res.data
          this.$log.debug("[ Axios / PartnerList / 파트너사 목록조회 ] 성공 => ", res.data)
        })
        .catch((err) => {
          this.$log.debug(err)
          alert('불러오기 실패!')
      })

    },

    /**
     * Title        : Row click
     * Status       : Actived
     * Description  : 선택된 화물의 정보를 변경하기 위한 모달 호출
     */
    onRowClick (evt, row) {
      this.$log.debug('파트너선택 = ', row)
      this.selectedList = [row]
      this.partnerModifyModalShow = true
    },

    async onPartnerDeleted() {
      this.partnerModifyModalShow = false
      this.selectedList = []
      await this.getPartnerList()
    },

    async onPartnerUpdated() {
      this.partnerModifyModalShow = false
      this.selectedList = []
      await this.getPartnerList()
    }
    
  },
  mounted() {
    this.getPartnerList()
  }
}
</script>


<template>

  <div class="partner-summary-grid q-mb-md">
    <q-card
      v-for="card in summaryCards"
      :key="card.label"
      flat
      bordered
      class="partner-summary-card">
      <q-card-section class="row items-center no-wrap q-gutter-md">
        <q-avatar
          :color="card.color"
          text-color="white"
          size="42px"
          :icon="card.icon" />
        <div>
          <div class="text-caption text-grey-7">{{ card.label }}</div>
          <div class="text-h6 text-weight-bold">{{ card.value }}</div>
        </div>
      </q-card-section>
    </q-card>
  </div>

  <div class="partner-filter-bar q-mb-md">
    <div class="row q-col-gutter-md items-end">
      <div class="col-12 col-md">
        <q-input
          v-model="filters.keyword"
          dense
          outlined
          clearable
          debounce="200"
          label="파트너 검색"
          placeholder="파트너명, 담당자, 이메일, 사업자번호 검색">
          <template #prepend>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <div class="col-12 col-md-3">
        <q-select
          v-model="filters.contractType"
          dense
          outlined
          emit-value
          map-options
          :options="contractTypeOptions"
          label="계약 서비스" />
      </div>
      <div class="col-12 col-md-3">
        <q-select
          v-model="filters.contractStatus"
          dense
          outlined
          emit-value
          map-options
          :options="contractStatusOptions"
          label="계약 상태" />
      </div>
      <div class="col-12 col-md-auto">
        <q-btn
          outline
          color="primary"
          icon="restart_alt"
          label="초기화"
          @click="resetFilters" />
      </div>
    </div>
  </div>

  <div class="row q-mb-sm">
    <div class="col">

      <q-table
        class="my-sticky-virtscroll-table"
        virtual-scroll
        v-model:selected="selectedList"
        :rows-per-page-options="[0]"
        :virtual-scroll-sticky-size-start="48"
        :rows="filteredPartnerList"
        :columns="columns"
        @row-click="onRowClick"
        row-key="id"
        no-data-label="조회되는 파트너가 없습니다.">

      </q-table>
    </div>
  </div>


  <!-- 파트너사 수정 모달 -->
  <teleport to="body">
    <q-dialog 
      v-model="partnerModifyModalShow">

      <PartnerInfoForm 
        :partnerInfo="selectedList[0]"
        :authLevel="String(session.authLevel || '')"
        :mode="modalMode"
        @reload-parcel-list="getPartnerList"
        @partnerUpdated="onPartnerUpdated"
        @partnerDeleted="onPartnerDeleted" />
    
    </q-dialog>
  </teleport>

</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.partner-summary-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.partner-summary-card {
  border-radius: 12px;
  background: #fff;
}

.partner-filter-bar {
  padding: 16px;
  border: 1px solid #e5e9f0;
  border-radius: 12px;
  background: #f8fafc;
}

@media (max-width: 1280px) {
  .partner-summary-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .partner-summary-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

</style>
